module.exports = __webpack_public_path__ + "img/mps-logo.b5e70958.svg";